class BuyCECourses extends HTMLElement {
  connectedCallback() {
    this.activeState = 'all';
    this.activeType  = 'all';
    this.userInteracted = false;

    this.querySelectorAll('[data-filter="state"]').forEach(btn =>
      btn.addEventListener('click', () => this.setFilter('state', btn))
    );
    this.querySelectorAll('[data-filter="type"]').forEach(btn =>
      btn.addEventListener('click', () => this.setFilter('type', btn))
    );

    this.filterPanels();
  }

  setFilter(dimension, activeBtn) {
    const selector  = dimension === 'state' ? '.buy-ce__filter-btn' : '.buy-ce__type-btn';
    const activeClass = selector.slice(1) + '--active';

    this.querySelectorAll(selector).forEach(btn => {
      const isActive = btn === activeBtn;
      btn.classList.toggle(activeClass, isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (dimension === 'state') this.activeState = activeBtn.dataset.handle;
    else                        this.activeType  = activeBtn.dataset.handle;

    this.userInteracted = true;
    this.filterPanels();
  }

  filterPanels() {
    let visibleCount = 0;

    this.querySelectorAll('.buy-ce__panel').forEach(panel => {
      const panelStates = (panel.dataset.states || 'all').split(' ');
      const panelType   = panel.dataset.courseType || 'all';

      const stateMatch =
        this.activeState === 'all' ||
        panelStates.includes('all') ||
        panelStates.includes(this.activeState);
      const typeMatch =
        this.activeType === 'all' || panelType === 'all' || panelType === this.activeType;

      const visible = stateMatch && typeMatch;
      panel.hidden = !visible;
      if (visible) visibleCount++;
    });

    if (this.userInteracted) {
      const container = this.querySelector('.buy-ce__panels');
      if (container) {
        container.classList.remove('buy-ce__panels--animate');
        void container.offsetHeight;
        container.classList.add('buy-ce__panels--animate');
      }
    }

    const noResults = this.querySelector('.buy-ce__no-results');
    if (noResults) noResults.hidden = visibleCount > 0;
  }
}

customElements.define('buy-ce-courses', BuyCECourses);
